import { TBEGenricResponse, TGenericDatasetQueryParams } from 'api/types';

export enum TStockTypeEnum {
  PhoneCase = 'phoneCase',
  Cup = 'cup',
}

export type TStockItem = {
  id: string;
  name: string;
  variation?: string;
  quantity: number;
  type: TStockTypeEnum;
};

export type TStockItemBE = TStockItem;

export type TStockGetListQueryParams = TGenericDatasetQueryParams;

export type TStockGetListByTypeQueryParams = TGenericDatasetQueryParams & {
  typeList: TStockTypeEnum[];
};

export type TStockGetListByIdsQueryParams = TGenericDatasetQueryParams & {
  idList: string[];
};

export type TStockGetListBE = TBEGenricResponse<{
  items: Array<TStockItemBE>;
}>;

export type TStockGetListByTypeBE = TBEGenricResponse<{
  [key in TStockTypeEnum]: Array<TStockItemBE>;
}>;

export type TStockGetListByIdsBE = TBEGenricResponse<{
  items: Array<TStockItemBE>;
}>;

export type TStockCreateBody = {
  name: string;
  variation?: string;
  quantity: number;
  type: TStockTypeEnum;
};
export type TStockCreateBE = TBEGenricResponse<TStockItem>;

export type TStockUpdateBody = {
  id: string;
  name?: string;
  variation?: string;
  quantity?: number;
  type?: TStockTypeEnum;
};
export type TStockUpdateBE = TBEGenricResponse<TStockItem>;

export type TStockReservationCreateBody = {
  stockItems: Array<{ id: string; quantity: number }>;
};
export type TStockReservationCreateBE = TBEGenricResponse<{ id: string }>;

export type TStockReservationAbortBody = {
  id: string;
};
export type TStockReservationAbortBE = TBEGenricResponse<TStockItem>;
